import { useState } from "react";

const defaultTitle = "Atenção!";

export const useDialogBox = () => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState(defaultTitle);
  const [message, setMessage] = useState("");
  const [type, setType] = useState("alert");
  const [resolution, setResolution] = useState(null);

  const handleClose = (e, reason) => reason !== "backdropClick" && setOpen(false);

  const handleConfirm = () => {
    if (resolution) {
      resolution.resolve(true);
    }
    handleClose();
  }

  const handleCancel = () => {
    if (resolution) {
      resolution.resolve(false);
    }
    handleClose();
  }

  const alert = (message, title = defaultTitle) => {
    return new Promise((resolve) => {
      setTitle(title);
      setMessage(message);
      setType("alert");
      setOpen(true);
      setResolution({resolve});
    });
  }

  const confirm = (message, title = defaultTitle) => {
    return new Promise((resolve) => {
      setTitle(title);
      setMessage(message);
      setType("confirm");
      setOpen(true);
      setResolution({resolve});
    });
  }

  return {
    open,
    title,
    message,
    type,
    handleClose,
    handleConfirm,
    handleCancel,
    alert,
    confirm,
  };
}
